import React from 'react';
import { AnimatedCounter } from '../UI/AnimatedCounter';
export const Stats = () => {
  const stats = [{
    value: 7,
    label: 'Active Cities'
  }, {
    value: 180,
    label: 'Community Members'
  }, {
    value: 100,
    label: 'Ideas & Brands Powered',
    suffix: '+'
  }, {
    value: 7,
    label: 'Salons Curated'
  }];
  return <section className="py-16 border-b-2 border-gray-300 bg-secondary/5" data-id="element-615">
      <div className="container mx-auto px-4" data-id="element-616">
        <h2 className="text-3xl font-bold text-center mb-12 text-secondary-dark" data-id="element-617">
          Our Impact
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-618">
          {stats.map((stat, index) => <div key={index} className="bg-white border-2 border-dashed border-gray-300 rounded-lg p-6 hover:border-solid hover:border-gray-400 transition-all" data-id="element-619">
              <AnimatedCounter end={stat.value} suffix={stat.suffix || ''} className="text-4xl font-bold text-primary" data-id="element-620" />
              <div className="mt-2 text-secondary" data-id="element-621">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
};